import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import "../../../styles/AppCss.css";
import { useParams, useSearchParams } from "react-router-dom";
import { getDetalleLocalPaginado } from "../../../api/ApiService";
import LocalDetalleComponents from "./components/LocalDetalleComponents";
import { Backdrop, CircularProgress } from "@mui/material";

function LocalDetallePage() {
    const [cargando, setCargando] = useState(false);
    const [dataLocal, setDataLocal] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(5);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [loadingCargar, setLoadingCargar] = useState(false);

    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const { id } = useParams();
    const [searchParams] = useSearchParams();

    const mode = searchParams.get('mode');

    console.log("id", id);
    console.log("searchParams", mode);

    useEffect(() => {
        //poner el scroll al top
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleLocal(1, perPage);
            }
        }

    }, [id, stateToken]);





    const handleDetalleLocal = (pageToLoad = 1, perPageToLoad = perPage) => {
        let body = {
            id: id,
            page: String(pageToLoad),
            per_page: String(perPageToLoad),
        };
        getDetalleLocalPaginado(stateToken?.access_token, body)
            .then((response) => {
                console.log("getDetalleLocalPaginado", response);
                setLoadingCargar(false);

                setCargando(true);
                setDataLocal(response?.data || null);
                setPage(pageToLoad);
            })
            .catch(() => {
                setCargando(true);
                setMensaje("Error al cargar los datos");
                setSeverity("error");
                setOpen(true);
                setLoadingCargar(false);
            });
    };

    const handlePageChange = (nextPage) => {
        if (!dataLocal?.giftcards_canjes?.last_page) return;
        if (nextPage < 1 || nextPage > dataLocal.giftcards_canjes.last_page) return;
        setLoadingCargar(true);
        handleDetalleLocal(nextPage, perPage);
    };

    const handlePerPageChange = (nextPerPage) => {
        setPerPage(nextPerPage);
        setLoadingCargar(true);

        handleDetalleLocal(1, nextPerPage);
    };



    const handleCancelar = () => {
        window.history.back();
    };

    const handleClose = () => {
        setOpen(false);
    };










    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-6">
                        <h1 className="mb-1 text-2xl font-bold text-gray-800">
                            {/* {id ? "Actualizar Local" : "Crear Local"} */}
                            {id ? (mode === "view" ? "Detalle Local" : "Actualizar Local") : "Crear Local"}
                        </h1>
                        <p className="text-sm text-gray-500">
                            {id ? (mode === "view" ? "Visualiza la información del local." : "Actualiza la información del local.") : "Carga la imagen y completa la información principal del local."}
                        </p>
                    </div>

                    {cargando ? (
                        <LocalDetalleComponents
                            data={dataLocal}
                            handleCancelar={handleCancelar}
                            onPageChange={handlePageChange}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                        />
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {open && (
                <div className="fixed right-4 top-4 z-[10000] max-w-sm">
                    <div
                        className={`rounded-xl border px-4 py-3 shadow-lg ${severity === "success"
                            ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                            : severity === "warning"
                                ? "border-amber-200 bg-amber-50 text-amber-700"
                                : "border-red-200 bg-red-50 text-red-700"
                            }`}
                    >
                        <div className="flex items-start justify-between gap-4">
                            <p className="text-sm font-medium">{mensaje}</p>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="text-current opacity-70 transition-opacity hover:opacity-100"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </HeaderCustom>
    );
}

export default LocalDetallePage;
